<template>
  <div>
    <v-row>
      <v-col cols="12" md="12" sm="12">
        <v-data-table :loading="carregando ? 'success' : null" no-data-text="Nenhum Bloqueio encontrada(o)!"
          loading-text="Carregando os itens desta tabela! Aguarde..." :headers="colunasBloqueios"
          :header-props="headerProps" :items="listaBloqueios" :items-per-page="-1" hide-default-footer
          class="elevation-0">
          <template v-slot:top>
            <v-row>
              <v-col class="botao-novo" cols="12" sm="12" md="12">
                <v-btn class="btn-novo-bloqueio" @click="abrirModalBloqueios()">
                  <v-icon>mdi-plus</v-icon>
                  NOVO
                </v-btn>
              </v-col>
            </v-row>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn class="mx-2" x-small fab color="success" @click="abrirModalBloqueiosParaEdicao(item)"
              title="Editar Bloqueio">
              <v-icon small>mdi-pencil</v-icon>
            </v-btn>
            <v-btn class="mx-2" x-small fab color="error" @click="excluirBloqueio(item)" title="Excluir Bloqueio">
              <v-icon small>mdi-minus</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-dialog persistent v-model="modalBloqueios" max-width="900px" class="bloqueio-modal">
      <div class="bloqueio-modal-container">
        <div class="modal-header">
          <div class="header-content">
            <div class="header-left">
              <div class="header-icon">
                <v-icon class="header-icon-white">{{ iconeTituloBloqueios }}</v-icon>
              </div>
              <div class="header-text">
                <h2 class="header-title">{{ tituloBloqueios }}</h2>
                <p class="header-subtitle">Configure os bloqueios da agenda</p>
              </div>
            </div>
          </div>
        </div>
        <div class="unified-content">
          <v-card class="unified-card">
            <div class="form-content">
              <validation-observer ref="observerBloqueios" v-slot="{}">
                <v-form>
                  <v-row>
                    <v-col cols="12" md="6" sm="6">
                      <soi-input type="date" :name="'Início'" v-model="bloqueioAgenda.dataInicio" :label="'Início'"
                        :rules="{ required: true }"></soi-input>
                    </v-col>
                    <v-col cols="12" md="6" sm="6">
                      <soi-input type="date" :name="'Fim'" v-model="bloqueioAgenda.dataFim" :label="'Fim'"
                        :rules="{ required: true }"></soi-input>
                    </v-col>
                    <v-col cols="12" md="12" sm="12">
                      <soi-input :name="'Descrição'" v-model="bloqueioAgenda.descricao" :label="'Descrição'"
                        :rules="{ required: true }"></soi-input>
                    </v-col>
                  </v-row>
                </v-form>
              </validation-observer>
            </div>
            <div class="form-actions">
              <div class="actions-container">
                <v-btn class="action-btn cancel-btn" :class="'warning'" @click="fecharModal()">
                  <v-icon left>mdi-keyboard-return</v-icon>
                  Voltar
                </v-btn>
                <v-btn class="action-btn save-btn" @click="salvar()" :loading="carregando" :disabled="carregando">
                  <v-icon left>$saveIcon</v-icon>
                  Salvar
                </v-btn>
              </div>
            </div>
          </v-card>
        </div>
      </div>
    </v-dialog>
  </div>
</template>
<script lang="ts">
import Vue from 'vue';
import DateHelper from '../../helpers/DateHelper';
import { AlertaExclusaoQuestaoBooleano, MensagemMixin } from '../../helpers/MensagemHelper';
import BloqueioHorarioAgenda from '../../models/agenda/BloqueioHorarioAgenda';

export default Vue.extend({
  name: 'soi-bloqueioAgenda',
  props: {
    value: {
      type: Array as () => BloqueioHorarioAgenda[],
      required: true,
    },
    agenda: {
      type: Object as () => any,
      required: false,
      default: null,
    },
  },
  watch: {
    value() {
      this.listaBloqueios = this.value;
    },
  },
  computed: {
    tituloBloqueios() {
      return this.editarBloqueios ? 'Editar Bloqueios' : 'Criar Bloqueios';
    },
    iconeTituloBloqueios() {
      return this.editarBloqueios ? 'mdi-pencil' : 'mdi-plus-circle';
    },
  },
  data() {
    return {
      carregando: false,
      bloqueioAgenda: new BloqueioHorarioAgenda(),
      listaBloqueios: this.value,
      modalBloqueios: false,
      editarBloqueios: false,
      bloqueioAgendaEdicaoIndex: -1,
      headerProps: {
        sortByText: 'Ordenar por',
      },
      colunasBloqueios: [
        {
          text: 'Início',
          align: 'center',
          value: 'dataInicio',
          filterable: true,
          sortable: true,
        },
        {
          text: 'Fim',
          align: 'center',
          value: 'dataFim',
          filterable: true,
          sortable: true,
        },
        {
          text: 'Descrição',
          align: 'center',
          value: 'descricao',
          filterable: true,
        },
        {
          text: 'Ações',
          align: 'center',
          value: 'actions',
        },
      ],
    };
  },
  methods: {
    async salvar(): Promise<void> {
      const { dataInicio, dataFim } = this.bloqueioAgenda;
      const valid = await (this.$refs.observerBloqueios as { validate: () => Promise<boolean> }).validate();

      if (!valid) {
        return;
      }

      if (!this.validaDatas(dataInicio, dataFim)) {
        await (this.$refs.observerBloqueios as any).reset();
        return;
      }

      if (this.agenda && this.agenda.listaFeriados && this.agenda.listaFeriados.length > 0) {
        const normalizarData = (dataStr: string): Date => {
          if (!dataStr) return new Date();
          let data: Date;
          if (dataStr.includes('/') && dataStr.split('/').length === 3) {
            const [dia, mes, ano] = dataStr.split('/');
            data = new Date(parseInt(ano, 10), parseInt(mes, 10) - 1, parseInt(dia, 10));
          } else if (dataStr.includes('-') && dataStr.split('-').length === 3) {
            const [ano, mes, dia] = dataStr.split('-');
            data = new Date(parseInt(ano, 10), parseInt(mes, 10) - 1, parseInt(dia, 10));
          } else {
            data = new Date(dataStr);
          }
          if (Number.isNaN(data.getTime())) {
            return new Date();
          }
          return new Date(data.getFullYear(), data.getMonth(), data.getDate());
        };

        const dataInicioNormalizada = normalizarData(dataInicio);
        const dataFimNormalizada = normalizarData(dataFim);

        const feriadosNoPeriodo = this.agenda.listaFeriados.filter((feriado: any) => {
          const dataFeriado = normalizarData(feriado.data);
          return dataFeriado.getTime() >= dataInicioNormalizada.getTime()
              && dataFeriado.getTime() <= dataFimNormalizada.getTime();
        });

        if (feriadosNoPeriodo.length > 0) {
          const datasFormatadas = feriadosNoPeriodo.map((f: any) => {
            const dataNormalizada = normalizarData(f.data);
            const dia = String(dataNormalizada.getDate()).padStart(2, '0');
            const mes = String(dataNormalizada.getMonth() + 1).padStart(2, '0');
            const ano = dataNormalizada.getFullYear();
            return `${dia}/${mes}/${ano}`;
          });
          MensagemMixin(5000, 'error', `Não é possível criar bloqueio. Existe(m) ${feriadosNoPeriodo.length} feriado(s) no período selecionado: ${datasFormatadas.join(', ')}. Remova o(s) feriado(s) primeiro.`);
          await (this.$refs.observerBloqueios as any).reset();
          return;
        }
      }

      this.bloqueioAgenda.dataInicio = DateHelper.formataParaDiaMesAno(dataInicio);
      this.bloqueioAgenda.dataFim = DateHelper.formataParaDiaMesAno(dataFim);

      if (this.editarBloqueios) {
        if (this.bloqueioAgendaEdicaoIndex !== -1) {
          Object.assign(this.listaBloqueios[this.bloqueioAgendaEdicaoIndex], this.bloqueioAgenda);
        }
      } else {
        this.listaBloqueios.push(this.bloqueioAgenda);
      }

      this.$emit('input', this.listaBloqueios);
      this.modalBloqueios = false;
      this.editarBloqueios = false;
      await (this.$refs.observerBloqueios as any).reset();
      this.bloqueioAgenda = new BloqueioHorarioAgenda();
    },
    validaDatas(dataInicio: string, dataFim: string) {
      let retorno: boolean = true;
      const inicio: Date = new Date(dataInicio);
      const fim: Date = new Date(dataFim);

      if (inicio > fim) {
        retorno = false;
        MensagemMixin(3000, 'error', 'A data final deve ser após a data inicial!');
        return retorno;
      }

      return retorno;
    },
    abrirModalBloqueios() {
      this.modalBloqueios = true;
      this.bloqueioAgenda = new BloqueioHorarioAgenda();
    },
    async abrirModalBloqueiosParaEdicao(bloqueio: BloqueioHorarioAgenda) {
      this.bloqueioAgendaEdicaoIndex = this.listaBloqueios.indexOf(bloqueio);
      this.editarBloqueios = true;
      this.modalBloqueios = true;

      setTimeout(() => {
        this.bloqueioAgenda = { ...bloqueio };
        this.bloqueioAgenda.dataInicio = DateHelper.formatarParaAnosMesDiaSubstring(bloqueio.dataInicio);
        this.bloqueioAgenda.dataFim = DateHelper.formatarParaAnosMesDiaSubstring(bloqueio.dataFim);
      }, 10);
    },
    async excluirBloqueio(bloqueio: BloqueioHorarioAgenda) {
      if (await AlertaExclusaoQuestaoBooleano()) {
        const index = this.listaBloqueios.indexOf(bloqueio);
        this.listaBloqueios.splice(index, 1);
        this.$emit('input', this.listaBloqueios);
      }
    },
    async fecharModal() {
      this.modalBloqueios = false;
      this.editarBloqueios = false;
      await (this.$refs.observerBloqueios as any).reset();
      this.bloqueioAgenda = new BloqueioHorarioAgenda();
    },
  },
});
</script>

<style scoped>
/* BOTÃO NOVO MODERNO */
.btn-novo-bloqueio {
  background: var(--especialidade-primary, #2e4b9d) !important;
  color: white !important;
  border-radius: 12px !important;
  padding: 12px 24px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  font-size: 14px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  transition: all 0.3s ease !important;
  margin-bottom: 16px !important;
}

.btn-novo-bloqueio:hover {
  background: var(--especialidade-secondary, #4a6bb5) !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(46, 75, 157, 0.3) !important;
}

.btn-novo-bloqueio .v-icon {
  color: white !important;
  margin-right: 8px !important;
}

/* MODAL BLOQUEIOS - ESTILO MODERNO */
.bloqueio-modal {
  z-index: 9999 !important;
}

.bloqueio-modal-container {
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
  max-width: 900px;
  margin: 0 auto;
}

/* HEADER MODERNO */
.modal-header {
  background: var(--especialidade-primary, #2e4b9d);
  padding: 24px 32px;
  position: relative;
}

.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 16px;
}

.header-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 12px;
}

.header-icon-white {
  color: white !important;
  font-size: 24px !important;
}

.header-text {
  flex: 1;
}

.header-title {
  color: white;
  font-size: 24px;
  font-weight: 600;
  margin: 0;
  line-height: 1.2;
}

.header-subtitle {
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
  margin: 4px 0 0 0;
  font-weight: 400;
}

.close-btn {
  color: white !important;
  opacity: 0.8;
  transition: opacity 0.2s ease;
}

.close-btn:hover {
  opacity: 1;
  background: rgba(255, 255, 255, 0.1) !important;
}

/* CONTEÚDO UNIFICADO */
.unified-content {
  padding: 0 24px 24px 24px;
}

.unified-card {
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.form-content {
  padding: 32px;
}

/* INPUTS MODERNOS */
.soi-input {
  margin-bottom: 16px;
}

.soi-input .v-input__control {
  border-radius: 12px !important;
  border: 2px solid var(--border-light, #e0e0e0) !important;
  transition: all 0.3s ease !important;
}

.soi-input .v-input__control:hover {
  border-color: var(--especialidade-primary, #2e4b9d) !important;
  box-shadow: 0 0 0 3px rgba(46, 75, 157, 0.1) !important;
}

.soi-input .v-input__control:focus-within {
  border-color: var(--especialidade-primary, #2e4b9d) !important;
  box-shadow: 0 0 0 3px rgba(46, 75, 157, 0.2) !important;
}

/* AÇÕES */
.form-actions {
  padding: 24px 32px 32px 32px;
  border-top: 1px solid var(--border-light, #f0f0f0);
  background: var(--bg-secondary, #fafafa);
}

.actions-container {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.action-btn {
  padding: 12px 24px !important;
  border-radius: 12px !important;
  font-weight: 600 !important;
  text-transform: none !important;
  font-size: 14px !important;
  min-width: 120px !important;
  height: 44px !important;
  transition: all 0.3s ease !important;
}


.cancel-btn:hover {
  background: var(--especialidade-gradient, #2e4b9d) !important;
  color: #ffffff !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.save-btn {
  background: var(--especialidade-primary, #2e4b9d) !important;
  color: white !important;
  border: 2px solid var(--especialidade-primary, #2e4b9d) !important;
}

.save-btn:hover {
  background: var(--especialidade-secondary, #4a6bb5) !important;
  border-color: var(--especialidade-secondary, #4a6bb5) !important;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(46, 75, 157, 0.3);
}

.save-btn .v-icon {
  color: white !important;
}

.cancel-btn .v-icon {
  color: #ffffff !important;
}

/* Dark mode overrides */
.theme--dark .form-actions {
  background: #363636;
  border-top-color: rgba(255, 255, 255, 0.12);
}

.theme--dark .soi-input .v-input__control {
  border-color: rgba(255, 255, 255, 0.3) !important;
}

/* RESPONSIVIDADE */
@media (max-width: 768px) {
  .bloqueio-modal-container {
    margin: 16px;
    max-width: calc(100vw - 32px);
  }

  .modal-header {
    padding: 20px 24px;
  }

  .header-title {
    font-size: 20px;
  }

  .form-content {
    padding: 24px;
  }

  .form-actions {
    padding: 20px 24px 24px 24px;
  }

  .actions-container {
    flex-direction: column;
  }

  .action-btn {
    width: 100% !important;
  }
}
</style>
